// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueI18n from 'vue-i18n';

import autoLocale from 'lib/autoLocale';
import App from './App.vue';
import store from './store';
import messages from './i18n';

Vue.filter('number', (n) => {
  if (typeof n !== 'number' || isNaN(n)) return n;

  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: autoLocale(Object.keys(messages)),
  fallbackLocale: 'en',
  messages,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js